import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'
import { setupHashScroll, teardownHashScroll } from '../hash_scroll'

export default class extends Controller {
  static targets = ['overlay', 'moreButton', 'moreText', 'plans', 'expertTooltip']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  connect () {
    this.overlayTargets.forEach((target) => {
      target.classList.add('viewcomponent::site::pages::facility::summary::mobile::visible')
    })

    setupHashScroll(this)
  }

  disconnect () {
    teardownHashScroll(this)
  }

  hide (e) {
    e.target.classList.remove('viewcomponent::site::pages::facility::summary::mobile::visible')
  }

  scrollTo (id) {
    const anchor = document.querySelector(id)
    this.scroll.animateScroll(anchor)
  }

  scrollOrRedirectToAccess (e) {
    const plansSection = document.getElementById('access')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#access')
    }
  }

  // SP: ファーストビューの地図アイコンから #access 内のフルスクリーン地図モーダルを起動する。
  // アイコンとモーダルは別コンポーネント（別コントローラー）のため、windowカスタムイベントで疎結合に連携する。
  openMapModal (e) {
    const modal = document.querySelector('[data-controller~="site--parts--facility--map-modal--mobile--component"]')
    if (modal) {
      e.preventDefault()
      window.dispatchEvent(new CustomEvent('map-modal:open'))
    } else {
      // モーダルが無い環境ではアクセスセクションへのスクロールにフォールバックする
      this.scrollOrRedirectToAccess(e)
    }
  }

  scrollOrRedirectToReviews (e) {
    const reviewsSection = document.getElementById('reviews')
    if (reviewsSection) {
      this.scrollTo('#reviews')
    } else {
      window.location.href = e.target.dataset.url
    }
  }

  scrollOrRedirectToAdmissionPlans (e) {
    const plansSection = document.getElementById('plans')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#plans')
    }
  }

  // NOTE: desktop側のcomponent_controller.jsにも同一メソッドあり
  // mobile/desktopは独立したViewComponentのため、共通基底クラスではなく各コントローラーに定義
  scrollToElement (e) {
    const link = e.target.closest('a')
    if (link && link.hash) {
      const anchor = document.querySelector(link.hash)
      if (anchor) {
        e.preventDefault()
        this.scrollTo(link.hash)
        return
      }
    }
    const plansSection = document.getElementById('plans')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#plans')
    }
  }

  more () {
    this.moreButtonTarget.style.display = 'none'
    this.moreTextTarget.style.display = 'inline'
  }

  get className () {
    return this.element.dataset.classname
  }

  toggle () {
    if (this.expertTooltipTargets[0].classList.contains(`${this.className}::accordion-close`)) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this.expertTooltipTargets.forEach((target) => {
      target.classList.remove(`${this.className}::accordion-close`)
      target.classList.add(`${this.className}::accordion-open`)
    })
  }

  close () {
    this.expertTooltipTargets.forEach((target) => {
      target.classList.remove(`${this.className}::accordion-open`)
      target.classList.add(`${this.className}::accordion-close`)
    })
  }
}
